import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { DEFAULT_LANG, SUPPORTED_LANGS } from "./paths";

import svCommon from "./locales/sv/common.json";
import svHome from "./locales/sv/home.json";
import svAirport from "./locales/sv/airport.json";
import svFlight from "./locales/sv/flight.json";
import svRoute from "./locales/sv/route.json";
import svRoutle from "./locales/sv/routle.json";
import svReseservice from "./locales/sv/reseservice.json";
import svSeo from "./locales/sv/seo.json";
import svConsent from "./locales/sv/consent.json";
import svLegal from "./locales/sv/legal.json";

import enCommon from "./locales/en/common.json";
import enHome from "./locales/en/home.json";
import enAirport from "./locales/en/airport.json";
import enFlight from "./locales/en/flight.json";
import enRoute from "./locales/en/route.json";
import enRoutle from "./locales/en/routle.json";
import enReseservice from "./locales/en/reseservice.json";
import enSeo from "./locales/en/seo.json";
import enConsent from "./locales/en/consent.json";
import enLegal from "./locales/en/legal.json";

if (!i18n.isInitialized) {
  i18n.use(initReactI18next).init({
    resources: {
      sv: {
        common: svCommon, home: svHome, airport: svAirport, flight: svFlight,
        route: svRoute, routle: svRoutle, reseservice: svReseservice, seo: svSeo,
        consent: svConsent, legal: svLegal,
      },
      en: {
        common: enCommon, home: enHome, airport: enAirport, flight: enFlight,
        route: enRoute, routle: enRoutle, reseservice: enReseservice, seo: enSeo,
        consent: enConsent, legal: enLegal,
      },
    },
    lng: DEFAULT_LANG,
    fallbackLng: DEFAULT_LANG,
    supportedLngs: SUPPORTED_LANGS,
    defaultNS: "common",
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
  });
}

export default i18n;